import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_input.scss'

import { InputAttributes, Props } from '../utils/types'

const cx = bind(styles)

export namespace InputVariantNS {
  export const error = 'error'
  export const none = ''
}

type InputVariant = typeof InputVariantNS.error | typeof InputVariantNS.none

export interface InputProps extends Props {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  value?: string
  variant?: InputVariant
}

const Input = React.forwardRef<HTMLInputElement, InputAttributes & InputProps>(
  ({ children, className, variant = InputVariantNS.none, ...props }, ref) => (
    <input
      ref={ref}
      className={cx(
        'core-input',
        {
          [`core-input--${variant}`]: variant,
        },
        className
      )}
      {...props}
    />
  )
)

Input.displayName = 'Input'

export default Input
